import { Component } from '@angular/core';
import { environment } from 'src/environments/environments';
import { OneSignal } from "onesignal-ngx";

import * as firebase from "firebase/app";
import "firebase/messaging";

import { AngularFireMessaging } from "@angular/fire/compat/messaging";

declare const window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
 messageReceived = false;
  messageData: any = {};
  tokenSent = false;
  isNotificationPermissionGranted = false;

  constructor(
    private oneSignal: OneSignal,
    private afMessaging: AngularFireMessaging
  ) {
   


    // this.oneSignal.init({
    //   appId: `${environment.OneSignalAppId}`,
    //   autoRegister: false,
    //   autoResubscribe: true,
    // });
    // this.oneSignal['setSubscription'](true);
    // this.oneSignal['setExternalUserId'](localStorage.getItem("_restId"));

    //     this.requestPermission();
    // this.initFirebaseMessaging();
  }


    initFirebaseMessaging() {
    this.afMessaging.messages.subscribe((payload: any) => {
      console.log("Message received:", payload);
      this.messageData = payload.notification;
      this.messageReceived = true;

      const notificationTitle = payload?.notification?.title;
      const notificationOptions = {
        body: payload?.notification?.body,
        icon: "assets/images/logo.png",
      };
      const notification = new Notification(
        notificationTitle,
        notificationOptions
      );
      notification.onclick = (event) => {
        event.preventDefault();
        window.location.href = "/food";
        notification.close();
      };

    });
  }

  requestPermission() {
    if ("Notification" in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {

          const fcmToken = localStorage.getItem("FCM_Token");
          console.log(fcmToken)
          if (!fcmToken) {
            this.afMessaging.requestToken.subscribe({
              next: (token: any) => {
                console.log("Token:", token);
                localStorage.setItem("FCM_Token", token);
              },
              error: (error: any) => {
                console.error(
                  "Error while requesting notification permission:",
                  error
                );
              },
            });
          } else {
            console.log("Token already sent:", fcmToken);
          }
        } else if (permission === "denied") {
          console.log("Notification permission denied.");
          // localStorage.setItem('FCM_Token', '');
          localStorage.removeItem("FCM_Token");
        }
      });
    }
  }
  
}
